import React, { Fragment, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Container, Card, CardBody } from "reactstrap";
import { useParams, useNavigate } from 'react-router-dom';
import { Breadcrumbs, Btn } from '../../../../AbstractElements'
import axios from "axios";
import config from "../../../../config";
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

const StatusChange = () => {

    const manageTenant = localStorage.getItem("manageTenants");
    const manageGeneralSettings = localStorage.getItem("manageGeneralSettings");

    if ((manageTenant === "0" && manageGeneralSettings === "0")) {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const { id } = useParams();
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const token = localStorage.getItem("sessiontoken");
    const navigate = useNavigate();
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    const [tenant_name, setTenantName] = useState('');
    const [tenant_disableInitial, setTenantDisableInitial] = useState('');
    const [tenant_statusInitial, setTenantStatusInitial] = useState('');
    // The action picked in the dropdown - the server derives every date field
    // from this, so the order the form is filled in no longer matters.
    const [to_status, setToStatus] = useState('');
    // Operational status (Trading / Fitout / Closed ...) - independent of the
    // lifecycle status above. Pre-filled from the tenant and posted on every
    // submit, so leaving it alone re-saves the value it already had.
    const [tenant_current_status, setCurrentStatus] = useState('');
    const [reason, setReason] = useState('');
    const [tenant_mode_of_transfer, setModeofTransfer] = useState('');
    const [tenant_data_capture_method, setDataCaptureMethod] = useState('');
    const [arrayStausOption, setArrayStatusOption] = useState([]);
    const [alerMesage, setAlertMessage] = useState('');
    const [task, setTask] = useState('');
    const [selectedDate, setSelectedDate] = useState('');

    const arrayCurrentStatus = ['Trading', 'Fitout', 'Closed Temporarily/Renovation', 'Closed Permanently', 'POS/Server Migration'];
    const arrayCaptureMethod = ['API', 'DB', 'CSV', 'PDF', 'Push', 'Manual'];
    const arrayModeOfTransfer = ['API', 'Mail', 'FTP/SFTP', 'DB', 'Manual'];

    const today = new Date();
    const beforeDate = new Date(today);
    beforeDate.setDate(today.getDate() - 15);

    useEffect(() => {
        axios.get(`${config.hostname}/tenant/${id}`, configheader)
            .then((response) => {
                setTenantName(response.data.tenant_store_name)
                setTenantDisableInitial(response.data.tenant_disable)
                setTenantStatusInitial(response.data.tenant_status)
                setCurrentStatus(response.data.tenant_current_status || '')
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])


    useEffect(() => {
        const setStatusOption = async () => {
            if (tenant_disableInitial) {
                setArrayStatusOption(['Reactivate']);
            } else if (!tenant_statusInitial || tenant_statusInitial === 'null') {
                setArrayStatusOption(['UAT']);
            } else if (tenant_statusInitial === 'UAT') {
                setArrayStatusOption(['RTGL', 'Live']);
            } else if (tenant_statusInitial === 'RTGL') {
                setArrayStatusOption(['Live']);
            } else if (tenant_statusInitial === 'Live') {
                setArrayStatusOption(['Disable']);
            }
        };

        setStatusOption();
    }, [tenant_statusInitial, tenant_disableInitial]);


    const handleStatusChange = (value) => {
        setToStatus(value)

        if (value === 'Disable') {
            setAlertMessage('Are you sure you want to make ' + tenant_name + ' Disable?')
            setTask(tenant_name + ' Disabled')
        }
        else if (value === 'Reactivate') {
            setAlertMessage('Are you sure you want to make ' + tenant_name + ' Reactivate?')
            setTask(tenant_name + ' Reactivated')
        }
        else if (value) {
            setAlertMessage('Are you sure you want to make ' + tenant_name + ' ' + value + '?')
            setTask(tenant_name + ' Changed to ' + value)
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        SweetAlert.fire({
            title: alerMesage,
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            reverseButtons: true,
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                // The server validates the transition, decides which date field
                // to write, backfills the live transaction tables on go-live and
                // writes both logs.
                const data = {
                    to_status,
                    tenant_current_status,
                    date: selectedDate,
                    login_name,
                    login_id,
                    task, //for log
                    ...(reason && { reason }),
                    ...(tenant_data_capture_method && { tenant_data_capture_method }),
                    ...(tenant_mode_of_transfer && { tenant_mode_of_transfer }),
                };

                axios
                    .post(`${config.hostname}/tenant/changestatus/${id}`, data, configheader)
                    .then(() => {
                        toast.success("Successfully updated");
                        navigate(`${process.env.PUBLIC_URL}/admin/tenant/viewtenant/:layout`);
                    })
                    .catch((error) => {
                        toast.error(error.response?.data?.message || "Error");
                        console.log(error);
                    });
            }
        });

    }

    return (
        <Fragment>
            <Breadcrumbs parent='Tenant' title='Update Tenant Status' mainTitle={'Update Tenant Status -' + tenant_name} />
            <Container fluid={true}>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit} className="form-bookmark needs-validation">
                                    <Fragment>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Label>Tenant Status</Label>
                                                    <select name="tenantstatus" id="tenantstatus" placeholder="Select Tenant Status" className="form-control digits" required
                                                        onChange={(e) => handleStatusChange(e.target.value)}>
                                                        <option value="">Select Tenant Status</option>
                                                        {arrayStausOption.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))}
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label>Current Status</Label>
                                                    <select name="currentstatus" id="currentstatus" className="form-control digits" required
                                                        value={tenant_current_status}
                                                        onChange={(e) => setCurrentStatus(e.target.value)}>
                                                        <option value="">Select Current Status</option>
                                                        {arrayCurrentStatus.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))}
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label>Date</Label>
                                                    <input className="form-control" type="date" name="date" required
                                                        onChange={(e) => setSelectedDate(e.target.value)}
                                                        //min={beforeDate.toISOString().split('T')[0]}
                                                        max={today.toISOString().split('T')[0]}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {to_status === 'Live' && (
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label>Data Capture Method</Label>
                                                        <select name="datamethod" id="datamethod" className="form-control digits" required
                                                            onChange={(e) => setDataCaptureMethod(e.target.value)}>
                                                            <option value="">Select Method</option>
                                                            {arrayCaptureMethod.map((item, index) => (
                                                                <option key={index} value={item}>{item}</option>
                                                            ))}
                                                        </select>
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup>
                                                        <Label>Mode of Transfer</Label>
                                                        <select name="modeoftransfer" id="modeoftransfer" className="form-control digits" required
                                                            onChange={(e) => setModeofTransfer(e.target.value)}>
                                                            <option value="">Select Mode of Transfer</option>
                                                            {arrayModeOfTransfer.map((item, index) => (
                                                                <option key={index} value={item}>{item}</option>
                                                            ))}
                                                        </select>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        )}


                                        {(to_status === 'Disable' || to_status === 'Reactivate') && (
                                            <Row>
                                                <Col md='6'>
                                                    <Label>Reason</Label>
                                                    <textarea className="form-control" type="text" name="reason" placeholder="Reason"
                                                        onChange={(e) => setReason(e.target.value)} required
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                    </Fragment>
                                    <Row>
                                        <Col >
                                            <div className='text-end'>
                                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Update </Btn>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default StatusChange